import { Box } from "@chakra-ui/react";
import clsx from "clsx";
import React from "react";
import { PageContentContextProvider } from "shared/components/layout/PageContentContext";

export type PageContentWidth = "boxed" | "wide";

export interface PageContentProps {
  contentWidth?: PageContentWidth;
  isFullHeight?: boolean;
  hasHeader?: boolean;
}

const PageContent: React.FC<React.PropsWithChildren<PageContentProps>> = ({
  isFullHeight,
  hasHeader = true,
  contentWidth = "wide",
  children,
}) => (
  <PageContentContextProvider isFullHeight={isFullHeight}>
    <Box
      width="100%"
      flex={1}
      flexDirection="column"
      display={isFullHeight ? "flex" : undefined}
      minWidth={0}
      overflowY="auto"
      overflowX="hidden"
      pt={hasHeader ? 0 : "24px"}
      className={clsx({
        "mb-page-content": true,
        "mb-page-content-full-height": isFullHeight,
        "page-width-boxed": contentWidth === "boxed",
        "page-width-wide": contentWidth === "wide",
      })}
      sx={{
        "&.page-width-boxed": {
          px: "130px",
          maxWidth: `${1700 + 130 + 130}px`,
          marginLeft: "auto",
          marginRight: "auto",
        },
        "&.page-width-wide": {
          px: "24px",
          mx: "auto",
        },
      }}
    >
      {children}
    </Box>
  </PageContentContextProvider>
);

export default PageContent;
